/* In the event that local storage is full,
use session storage as a fallback */
const setStartTime = (nameOfTimer: string, startTime: string): void => {
  localStorage.setItem(nameOfTimer, startTime);
  sessionStorage.setItem(nameOfTimer, startTime);
};

const getStartTime = (nameOfTimer: string): number => {
  return (
    Number(sessionStorage.getItem(nameOfTimer)) ||
    Number(localStorage.getItem(nameOfTimer)) ||
    new Date().getTime()
  );
};

const removeStartTime = (nameOfTimer: string): void => {
  localStorage.removeItem(nameOfTimer);
  sessionStorage.removeItem(nameOfTimer);
};

const calculateTimeSpentInMilliseconds = (nameOfTimer: string): number => {
  const startTime = getStartTime(nameOfTimer);
  return new Date().getTime() - startTime;
};

export {
  setStartTime,
  getStartTime,
  calculateTimeSpentInMilliseconds,
  removeStartTime,
};
